module.exports = __webpack_public_path__ + "media/images/img_kawabuchi-01850a809e4fc6813d112f9e1c8677b7.jpg";